import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    isReveal: true,
    isDrawerOpen: false,
}

const slice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        sidebarReveal: (state) => {
            state.isReveal = !state.isReveal
            state.isDrawerOpen = state.isDrawerOpen
        },
        sidebarOpenDrawer: (state) => {
            state.isReveal = state.isReveal
            state.isDrawerOpen = !state.isDrawerOpen
        },
        setSidebarReveal: (state, action) => {
            state.isReveal = action.payload
        }   
    }
})

const { sidebarOpenDrawer, sidebarReveal, setSidebarReveal } = slice.actions
const sidebarReducer = slice.reducer

const sidebarSlice = {
    sidebarReveal,
    sidebarOpenDrawer,
    setSidebarReveal,
    sidebarReducer,
}

export default sidebarSlice